import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Outer = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    padding: ${layout.horizontalPadding};
    box-sizing: border-box;
  }
`;

export const OuterSticky = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    padding: ${layout.horizontalPadding};
    box-sizing: border-box;
    position: sticky;
    top: 0;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: var(--gallery-mobile-height, auto);
  overflow: hidden;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: var(--gallery-desktop-height, 100%);
    border-radius: 20px;
  }
`;

export const Track = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  transform: translateX(calc(var(--gallery-index, 0) * -100%));
  transition: transform 0.35s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Slide = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
`;

export const Img = styled.img`
  width: 100%;
  display: block;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    object-fit: cover;
  }
`;

export const Placeholder = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  background: ${colors.lightGrey};
  border-radius: inherit;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: ${space[6]};
  background: linear-gradient(rgba(0, 0, 0, 0.35), transparent);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[7]};
    border-radius: 20px 20px 0 0;
    background: none;
  }
`;

export const Controls = styled.div`
  position: absolute;
  bottom: ${space[4]};
  left: ${space[5]};
  right: ${space[5]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;

  @media (min-width: ${layout.desktopBreakpoint}) {
    bottom: ${space[6]};
    left: ${space[6]};
    right: ${space[6]};
  }
`;

export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  background: ${colors.white};
  border-radius: ${layout.borderRadiusFull};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
`;

export const Dots = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[2]};
`;

export const Dot = styled.button`
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: ${layout.borderRadiusFull};
  background: ${colors.white};
  opacity: 0.5;
  cursor: pointer;
  transition: width 0.2s ease;

  &[data-active='true'] {
    width: 20px;
    opacity: 1;
  }
`;

export const BadgeContainer = styled.div`
  position: absolute;
  bottom: ${layout.horizontalPadding};
  left: ${space[4]};
  z-index: 2;

  @media (min-width: ${layout.desktopBreakpoint}) {
    bottom: ${space[5]};
    left: ${space[5]};
  }
`;

export const DefaultBadge = styled.span`
  display: inline-block;
  background: ${colors.sale};
  color: ${colors.white};
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  padding: 6px 14px;
  border-radius: ${space[1]};
`;
